import React, { FC, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import "../style/css/ScheduleGrid.css";
import { useNavigate, useParams } from "react-router-dom"; // Importa useNavigate y useParams

interface ScheduleItem {
  day: string;
  startTime: string;
  endTime: string;
  duration: number;
}

interface ScheduleGridProps {
  scheduleItems: ScheduleItem[];
}

const ScheduleGrid: FC<ScheduleGridProps> = ({ scheduleItems }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const formatTime = (timeString: string) => {
    return new Date(`1970-01-01T${timeString}`).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  const handleEditClick = () => {
    if (id) {
      navigate(`/offices/${id}/availability`);
    }
  };

  return (
    <div className="schedule-section">
      <h2 className="section-title">Horario de Disponibilidad</h2>
      <button className="new-save-button" onClick={handleEditClick}>
        {" "}
        <FontAwesomeIcon icon={faClock} style={{ marginRight: "8px" }} />
        Editar horarios
      </button>
      <div className="grid-container schedule-grid">
        {scheduleItems.map((item) => (
          <div className="info-box" key={item.day}>
            <FontAwesomeIcon
              icon={faClock}
              className="grid-icon"
              style={{ fontSize: "2.3rem" }}
            />
            <div className="grid-content">
              <h3>{item.day}</h3>
              <div className="time-slot">
                <p className="time-range">
                  {formatTime(item.startTime)} - {formatTime(item.endTime)}
                </p>
                <div className="duration-badge">
                  <span>{item.duration} min</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScheduleGrid;
